angular.module('dental')
	.directive('popup', ['popupService', '$timeout', function (popupService, $timeout) {
		return {
			restrict: 'AC',
			link: function ($scope, $element, $attrs) {
				let destroy;
				$element.on('click', function (e) {
					// TODO Test it whole project!
					var $target = $(e.target);
					if (
						$target.is('.popup:visible') &&
						(angular.isUndefined($attrs.popupType) || $attrs.popupType !== 'confirm')
					) {
						$scope.ctrl.popup = '';
					}
				});

				function update() {
					return $timeout(function() {
						$scope.popup = '';
						$scope.popupShowed = false;
						$scope.$apply();
					}, +$attrs.hideTimeout);
				}

				$scope.$watchGroup(['ctrl.popup', 'popupShowed'], function(val) {
					if (val[0] && $attrs.hideTimeout && $attrs.popup === val[0] && !val[1]) {
	
						destroy && $timeout.cancel(destroy);
						destroy = update();
	
						$element.on('mouseleave', function(/*e*/) {
							destroy && $timeout.cancel(destroy);
							destroy = update();
						});
						$element.on('mouseenter', function(/*e*/) {
							destroy && $timeout.cancel(destroy);
						});
	
						$scope.ctrl.popupShowed = true;
					}
				});

				if (angular.isUndefined(Object.getOwnPropertyDescriptor($scope.ctrl, 'popup'))) {
					Object.defineProperty($scope.ctrl, 'popup', {
						get: function () {
							return this.value;
						},
						set: function (val) {
							popupService(val);
							this.value = val;
						}
					});
				}
			}
		};
	}]);